import './in-evidenza.scss';

import Splide from '@splidejs/splide';
import { Translations } from '../utils';

export class InEvidenza {
  constructor() {
    this.els = document.querySelectorAll('.in-evidenza .splide');

    if (!this.els.length === 0) {
      return;
    }

    for (let i = 0; i < this.els.length; i += 1) {
      this.initSlider(this.els[i]);
    }
  }

  initSlider(el) {
    const isRightPanel = el.closest('.in-evidenza__col--right') !== null;

    const splide = new Splide(el, {
      type: 'slide',
      arrows: true,
      pagination: false,
      gap: isRightPanel ? '65px' : '24px',
      autoWidth: true,
      focus: 0,
      trimSpace: true,
      snap: true,
      mediaQuery: 'min',
      breakpoints: {
        768: {
          destroy: true,
        },
      },
      i18n: Translations.getSplideI18n(),
    });
    splide.mount();

    const next = el.querySelector('.splide__arrow--next');
    const updateArrows = () => {
      if (!window.matchMedia('(min-width: 400px)').matches) return;
      const { index } = splide;
      const last = splide.length - 2;

      // Se sono all’ultima slide disabilito next
      if (index >= last) {
        next.classList.add('is-disabled');
      } else {
        next.classList.remove('is-disabled');
      }
    };

    // primo chek al caricamento
    updateArrows();
    // secondo check al cambio slide
    splide.on('mounted move', updateArrows);
  }
}
